export enum ContentEnum {
  COURSE = "Course",
  CLASS = "Class",
  SUBJECT = "Subject",
  TOPIC = "Topic",
  CHAPTER = "Chapter",
  COURSE_CHAPTER = "CourseChapter",
  KSC_CLUSTER = "KSCCluster",
  KSC = "KSC",
  QUESTION = "Question",
  VIDEO = "Video",
}

export enum SearchContentEnum {
  COURSE = "Course",
  CLASS = "Class",
  SUBJECT = "Subject",
  TOPIC = "Topic",
  CHAPTER = "Chapter",
  KSC_CLUSTER = "KSCCluster",
  KSC = "KSC",
  QUESTION = "Question",
}

export enum QuestionTypeEnum {
  OBJECTIVE = "Objective",
  SUBJECTIVE = "Subjective",
  MULTIPLE_CHOICE = "Multiple Choice",
  NUMERICAL = "Numerical",
  ASSERTION_REASON = "Assertion and Reason",
  COMPREHENSION = "Comprehension",
  MATCH_THE_COLUMN = "MatchTheColumn",
  TRUE_FALSE = "True/False",
}

export enum QuestionLevelIdEnum {
  LEVEL1 = 1,
  LEVEL2 = 2,
}

export enum QuestionTypeIdEnum {
  OBJECTIVE = 1,
  SUBJECTIVE = 2,
  MULTIPLE_CHOICE = 3,
  NUMERICAL = 4,
  ASSERTION_REASON = 5,
  COMPREHENSION = 6,
  MATCH_THE_COLUMN = 7,
  TRUE_FALSE = 8,
}

export enum DifficultyLevelEnum {
  EASY = 1,
  MEDIUM = 2,
  HARD = 3,
}

export enum DifficultyGroupEnum {
  BASIC = "Basic",
  EASY = "Easy",
  NORMAL = "Normal",
  HARD = "Hard",
  TOUGH = "Tough",
}

export enum QuestionLevelIdsEnum {
  LEVEL1 = 1,
  LEVEL2 = 2,
}

export enum QuestionCategoryIdsEnum {
  GENERAL = 1,
  EXAMPLE = 2,
  ASSIGNMENT = 3,
  QUIZ = 4,
  TEST = 5,
  RECOMMENDED = 9,
  INSTITUTE = 10,
}

export enum QuestionSelectorSortEnum {
  DIFFICULTY = 1,
  CONCEPTS = 2,
  NEWEST = 3,
}
export enum QuestionBloomsTaxonomyIdsEnum {
  REMEMBERING = 1,
  UNDERSTANDING = 2,
  APPLYING = 3,
  ANALYZING = 4,
  EVALUATING = 5,
  CREATING = 6,
}

export enum QuestionIsActiveEnum {
  ACTIVE = 1,
  SUSPENDED = 2,
}

// Enum values are linked to QuestionDisplayStatusIdEnum in DataAPI project

export enum QuestionDisplayTypeEnum {
  HTML = "RenderedHtml",
  DESKTOP = "DesktopImage",
  MOBILE = "MobileImage",
}

export enum QuestionPdfImageTypeEnum {
  PAGE = "page",
  QUESTION = "question",
  SOLUTION = "solution",
}

export enum QuestionSerialNumberClassEnum {
  IS_TAGGED = "success",
  NOT_TAGGED = "secondary",
  IS_SELECTED = "primary",
}

export enum QuestionPdfStatusEnum {
  PDF_UPLOADED = 1,
  PDF_PROCESSED = 2,
  PDF_FAILED = 3,
  PDF_VERIFIED = 4,
  IMAGES_EXTRACTED = 5,
  EXTRACTION_FAILED = 6,
  IMAGES_SAVED = 7,
  QUESTION_BANK = 8,
  PDF_ARCHIVED = 9,
}

export enum QuestionDisplayStatusIdEnum {
  NEW_QUESTION = 1,
  LATEX_CONVERTED = 2,
  LATEX_APPROVED = 3,
  LATEX_REJECTED = 4,
  LATEX_REVIEW_REJECTED = 8,
  HTML_CONVERTED = 9,
  HTML_REVIEWED = 10,
  HTML_CONVERSION_FAILED = 11,
  LATEX_EDIT_NEEDED = 12,
  FINAL_APPROVED = 13,
  LATEX_FAILED = 99,
}

export enum QuestionTaggingStatusEnum {
  LATEX_APPROVED = QuestionDisplayStatusIdEnum.LATEX_APPROVED,
  LATEX_REJECTED = QuestionDisplayStatusIdEnum.LATEX_REJECTED,
  LATEX_EDIT_NEEDED = QuestionDisplayStatusIdEnum.LATEX_EDIT_NEEDED,
}

export enum QuestionFinalReviewStatusEnum {
  REJECTED = QuestionDisplayStatusIdEnum.LATEX_EDIT_NEEDED,
  APPROVED = QuestionDisplayStatusIdEnum.FINAL_APPROVED,
}

export enum QuestionTaggingTabsEnum {
  QUESTION = "Question",
  SOLUTION = "Solution",
}
export enum QuestionReviewTabsEnum {
  VIEW_MODE = "View Mode",
  EDIT_MODE = "Edit Mode",
}

export enum QrTargetTypeIdEnum {
  PDF = 1,
  PRESENTATION = 2,
  IMAGE = 3,
  VIDEO = 4,
  PLATFORM_LINK = 5,
}

export enum QrImageTypeEnum {
  SIMPLE = 1,
  QR_WITH_TITLE = 2,
  QR_WITH_DETAILS = 3,
}

export enum QrCategoryEnum {
  ANSWER_KEY_WORKBOOK = 1,
  ANSWER_KEY_FEB_EDITION = 9,
  ANSWER_KEY_SAMPLE_EDITION = 99,
  VIDEO_CONCEPT = 4,
  VIDEO_ACTIVITY = 5,
  VIDEO_QUESTION_SOLUTION = 6,
  QUESTION_HINTS = 7,
  CHAPTER_SELF_PRACTICE = 8,
  CHAPTER_BEGINNER_TEST = 10,
  CHAPTER_CHALLENGER_TEST = 11,
  CHAPTER_ADVANCED_TEST = 12,
  CONCEPT_QUIZ = 13,
  CONCEPT_QUIZ_PDF = 14,
}

export enum SavedTemplatesSortEnum {
  CREATED_ON = 1,
  TEST_NAME = 2,
  DURATION = 3,
  DIFFICULTY = 4,
}

export enum QuestionSimilarityTypeIdsEnum {
  DUPLICATE = 1,
  SIMILAR = 2,
}
export enum QuestionSimilarityStatusEnum {
  NEW = 1,
  APPROVED = 2,
  REJECTED = 3,
}

export enum ManageQrTabsEnum {
  BY_CATEGORY = "By Category",
  BY_CHAPTER = "By Chapter",
}

export enum PreloadedContentCategoryEnum {
  AFFILIATION = 1,
  STUDENT = 2,
  INTERNAL = 3,
}

export enum PreloadedContentTypeEnum {
  PRELOADED_ASSIGNMENTS = 1,
  PRELOADED_TESTS = 2,
  PAST_YEAR_PAPER = 3,
}

export enum SmartBooksContentTypeEnum {
  SUMMARY = 1,
  TOPIC = 2,
  QUESTIONS = 3,
}

export enum ContentSectionsEnum {
  QUESTION = "Question",
  ANSWER = "Answer",
  SOLUTION = "Solution",
}

export enum LanguageIdsEnum {
  ENGLISH = 1,
  HINDI = 2,
  GUJARATI = 3,
}

export enum LearnVideoTypeEnum {
  CONCEPT = 1,
  EXAMPLE = 2,
  LECTURE = 3,
  FAST_REVISION = 4,
  PAST_YEAR_QUESTION = 5,
}
